export default "__VITE_ASSET__BlH1CR49__"